import { useRef } from "react";
import { useState } from "react";
import { SetPin } from "./SetPin";
import { SetSecurityQuestion } from "./SetSecurityQuestion";

interface ISetPinModal {}

const SetPinModal: React.FC<ISetPinModal> = () => {
  const [section, setSection] = useState<"questions" | "pin">("questions");
  const dismissRef = useRef<null | HTMLButtonElement>(null);
  const dismissModal = () => {
    dismissRef?.current?.click();
  };

  return (
    <div
      className="modal fade"
      id="setPinModal"
      tabIndex={-1}
      aria-labelledby="setPinModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content p-4">
          <div className="modal-header p-0 pb-2">
            <h5 className="page-subtitle">
              {section === "questions"
                ? "Security Questions"
                : "Transaction PIN"}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissRef}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body px-0">
            {(() => {
              switch (section) {
                case "questions":
                  return <SetSecurityQuestion setSection={setSection} />;
                case "pin":
                  return <SetPin dismissModal={dismissModal} />;
                default:
                  return null;
              }
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SetPinModal;
